function preventEvent (e) {
  e.stopImmediatePropagation()
}

export function DisabledDirective (el: HTMLElement, binding: any) {
  if (binding.value) {
    el.setAttribute('directive-disabled', '')
    el.addEventListener('click', preventEvent, true)
  } else {
    el.removeAttribute('directive-disabled')
    el.removeEventListener('click', preventEvent, true)
  }
}
